import React from "react";

/**
 * Rend un formulaire NON MODIFIABLE sans toucher à chacun de ses champs.
 *
 * `<fieldset disabled>` désactive nativement TOUS les contrôles de formulaire qu'il contient —
 * c'est du HTML, pas une astuce React. L'alternative aurait été d'ajouter `disabled={readOnly}`
 * sur chaque `Input`, `Dropdown`, `Switch` et `Checkbox` de six formulaires, dont un de 1200
 * lignes : autant d'occasions d'en oublier un, et rien pour le détecter.
 *
 * ⚠️ CE QUE ÇA NE COUVRE PAS : un contrôle qui n'est pas un élément de formulaire — un `div`
 * cliquable, un glisser-déposer, un composant tiers qui gère lui-même son état. La ceinture reste
 * donc le bouton d'enregistrement, MASQUÉ en lecture seule ; et la bretelle, le backend, dont le
 * verrou de lecture seule refuse l'écriture quoi que fasse l'interface.
 *
 * Les styles neutralisent l'apparence par défaut du fieldset (bordure, marges) et son
 * `min-inline-size: min-content`, qui casserait les mises en page en grille.
 */
export const ReadOnlyFieldset = ({ readOnly, children }) => {
    if (!readOnly) return <>{children}</>;
    return (
        <fieldset
            disabled
            className="read-only-fieldset"
            style={{ border: "none", margin: 0, padding: 0, minInlineSize: 0 }}
        >
            {children}
        </fieldset>
    );
};

export default ReadOnlyFieldset;
